<template>
  <div>
    <v-row>
      <v-col
        :cols="isMobile ? 12 : 3"
        v-for="(dataArr, i) in staffData"
        :key="i + Math.random() + Math.random()"
        class="ml-4 pt-4"
      >
        <v-text-field
          :label="dataArr[0].toUpperCase().replace('_', ' ').split(' ')[0]"
          v-if="isAdmin"
          class="mx-2 mb-4"
          :value="dataArr[1]"
          @change="updateField(dataArr[0], staff.id)"
        ></v-text-field>
        <span
          v-else
          class="mx-2 mt-4"
          @change="updateField(dataArr[0], staff.id)"
          >{{ dataArr[1] }}</span
        >
      </v-col></v-row
    >
  </div>
</template>

<script>
import mainJs from "../main";

export default {
  props: {
    staff: {
      default: null,
    },
    table: {
      default: "staff",
    },
  },
  watch: {
    staff(newStaff) {
      this.getUserProfile(newStaff);
    },
  },
  computed: {
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
    getApiUrl() {
      return this.$store.getters.getApiUrl;
    },
    getUpdateModelSingleRowRoute() {
      return this.$store.getters.getUpdateModelSingleRowRoute;
    },
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
  },
  mounted() {
    this.getUserProfile(this.staff);
  },
  data: () => ({
    staffData: [],
    selectedStaff: null,
  }),
  methods: {
    getUserProfile(staff) {
      if (staff != null) {
        this.staffData = [];
        const staffData = Object.entries(staff);
        staffData.forEach((dataArr) => {
          if (
            dataArr[0] != "id" &&
            dataArr[0] != "emis" &&
            !dataArr[0].includes("salary") &&
            !dataArr[0].includes("total") &&
            !dataArr[0].includes("sub_") &&
            !dataArr[0].includes("_at")
          ) {
            this.staffData.push(dataArr);
          }
        });
      }
    },
    async updateField(column, id) {
      const value = event.target.value;
      const staff = await mainJs.updateModelSingleRow(
        this.getApiUrl + this.getUpdateModelSingleRowRoute,
        this.table,
        column,
        id,
        value,
        this.getAccessToken
      );
      this.selectedStaff = staff;
      this.$emit("data-updated", staff);
      this.$toast.success("Data Updated Successfully!", { duration: 3000 });
    },
  },
};
</script>

<style></style>
